import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-right q-my-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_items_loader = _resolveComponent("async-items-loader")!
  const _component_mark_all_read_btn = _resolveComponent("mark-all-read-btn")!
  const _component_user_notification_item = _resolveComponent("user-notification-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_mini_pagination = _resolveComponent("mini-pagination")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Notifications",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_async_items_loader, {
        task: _ctx.task,
        "num-items": _ctx.userNotifications.length
      }, {
        default: _withCtx(() => [
          _createTextVNode(" You have no notifications. ")
        ]),
        _: 1
      }, 8, ["task", "num-items"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_mark_all_read_btn, {
          "user-id": _ctx.userId,
          onMarkedRead: _ctx.markAllRead
        }, null, 8, ["user-id", "onMarkedRead"])
      ]),
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNotifications, (userNotification) => {
            return (_openBlock(), _createBlock(_component_user_notification_item, {
              key: userNotification.id,
              "user-notification": userNotification,
              onMarkedOneRead: _ctx.set
            }, null, 8, ["user-notification", "onMarkedOneRead"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_mini_pagination, {
        class: "q-mt-md",
        "model-value": _ctx.page,
        "per-page": _ctx.perPage,
        total: _ctx.total,
        "onUpdate:modelValue": _ctx.changePage
      }, null, 8, ["model-value", "per-page", "total", "onUpdate:modelValue"])
    ]),
    _: 1
  }, 512))
}